var AuthState = /* @__PURE__ */ ((AuthState2) => {
  AuthState2["Uninitialized"] = "uninitialized";
  AuthState2["Initialized"] = "initialized";
  AuthState2["LoggedIn"] = "logged-in";
  AuthState2["LoggedOut"] = "logged-out";
  AuthState2["ParseHashFailed"] = "parse-hash-failed";
  return AuthState2;
})(AuthState || {});
function getLoggedInState(auth) {
  if (!auth || isUninitialized(auth) || isInitialized(auth)) {
    return "loading";
  }
  if (isLoggedIn(auth)) {
    return "logged-in";
  }
  return "logged-out";
}
const isState = (stateName) => (state) => state.state === stateName;
const isUninitialized = isState(
  "uninitialized"
  /* Uninitialized */
);
const isInitialized = isState(
  "initialized"
  /* Initialized */
);
const isLoggedInPasswordless = (state) => state.state === "logged-in" && state.type === "passwordless";
const isLoggedIn = (state) => state.state === "logged-in" && state.type === "regular";
const isParseHashFailed = isState(
  "parse-hash-failed"
  /* ParseHashFailed */
);
const isLoggedOut = isState(
  "logged-out"
  /* LoggedOut */
);
export {
  AuthState,
  getLoggedInState,
  isInitialized,
  isLoggedIn,
  isLoggedInPasswordless,
  isLoggedOut,
  isParseHashFailed,
  isUninitialized
};
//# sourceMappingURL=state.js.map
